const dropdownItems = [
  {
    routeName: 'Create Cost Management',
    label: 'costManagement.type.travelCost',
  },
  {
    routeName: 'Create Vehicle Cost Management',
    label: 'costManagement.type.vehicleCost',
  },
  {
    routeName: 'Create Other Cost Management',
    label: 'costManagement.type.otherCost',
  },
]

export default dropdownItems
